














































import Vue from 'vue';
import { Prop } from 'vue/types/options';
import { Backup } from '@/openapi-types';
import * as api from '@/util/api';
import { encodePathParameter } from '@/util/api';
import { mapActions } from 'pinia';
import { useAlerts } from '@/store/modules/alerts';
import { useNotifications } from '@/store/modules/notifications';

export default Vue.extend({
  name: 'RestoreBackupButton',
  props: {
    backup: {
      type: Object as Prop<Backup>,
      required: true,
    },
  },
  data() {
    return {
      showConfirmation: false as boolean,
      restoring: false as boolean,
    };
  },
  methods: {
    ...mapActions(useAlerts, ['checkAlertStatus']),
    ...mapActions(useNotifications, ['showError', 'showSuccess']),
    restoreBackup() {
      this.restoring = true;
      api
        .put(
          `/backups/${encodePathParameter(this.backup.filename)}/restore`,
          {},
        )
        .then(() => {
          this.$emit('restored');
          this.showSuccess(
            this.$t('backup.action.restore.success', {
              file: this.backup.filename,
            }),
          );
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.showConfirmation = false;
          this.restoring = false;
          this.checkAlertStatus();
        });
    },
  },
});
